var _path, _circle, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccountIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon_11_",
    xmlns: "http://www.w3.org/2000/svg",
    width: 38.676,
    height: 31.525,
    viewBox: "0 0 38.676 31.525",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M46.684,113.989a2.956,2.956,0,0,1-1.262.28H24.5a3,3,0,0,1-3-3A12.423,12.423,0,0,1,33.922,98.85H36a12.477,12.477,0,0,1,3.6.529l-.01.018a2.672,2.672,0,0,0,.98,3.651l.285.165c-.033.331-.051.664-.051,1s.018.667.051,1l-.285.165a2.672,2.672,0,0,0-.98,3.651l1.4,2.417a2.67,2.67,0,0,0,3.651.98l.285-.165a9.914,9.914,0,0,0,1.73,1v.331A2.657,2.657,0,0,0,46.684,113.989Z",
    transform: "translate(-21.5 -82.744)",
    fill: "#df9426"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4",
    "data-name": "Ellipse 4",
    cx: 6.73,
    cy: 6.73,
    r: 6.73,
    transform: "translate(6.73 0)",
    fill: "#df9426"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M117.791,93.516l-1.524-.88a7.894,7.894,0,0,0,0-4.091l1.524-.88a.637.637,0,0,0,.234-.87l-1.4-2.417a.637.637,0,0,0-.87-.234l-1.524.88a7.9,7.9,0,0,0-3.544-2.048V81.216a.636.636,0,0,0-.636-.636h-2.791a.636.636,0,0,0-.636.636v1.758a7.852,7.852,0,0,0-3.544,2.048l-1.524-.88a.637.637,0,0,0-.87.234l-1.4,2.417a.637.637,0,0,0,.234.87l1.524.88a7.893,7.893,0,0,0,0,4.091l-1.524.88a.637.637,0,0,0-.234.87l1.4,2.417a.637.637,0,0,0,.87.234l1.524-.88a7.9,7.9,0,0,0,3.544,2.048v1.758a.636.636,0,0,0,.636.636h2.791a.636.636,0,0,0,.636-.636V98.2a7.852,7.852,0,0,0,3.544-2.048l1.524.88a.637.637,0,0,0,.87-.234l1.4-2.417a.637.637,0,0,0-.234-.87Zm-9.134.288a3.214,3.214,0,1,1,3.214-3.214A3.214,3.214,0,0,1,108.656,93.8Z",
    transform: "translate(-79.434 -69.123)",
    fill: "#df9426"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountIcon);
export default __webpack_public_path__ + "static/media/account_icon.2147d19cc8a65377c6a50611adc92f6a.svg";
export { ForwardRef as ReactComponent };